import React from 'react';
import { homeLogoStrip } from './data';

const LOOP = [...homeLogoStrip.logos, ...homeLogoStrip.logos];

export const HomeLogoStrip: React.FC = () => {
  return (
    <section className="io-home-logos" aria-labelledby="io-home-logos-title">
      <h2 id="io-home-logos-title" className="io-home-logos__title">
        {homeLogoStrip.title}
      </h2>
      <div className="io-home-logos__viewport">
        <div className="io-home-logos__track">
          {LOOP.map((logo, index) => {
            const isClone = index >= homeLogoStrip.logos.length;
            return (
              <div
                key={`${logo.src}-${index}`}
                className="io-home-logos__tile"
                aria-hidden={isClone}
              >
                <img
                  src={logo.src}
                  alt={isClone ? '' : logo.alt}
                  className="io-home-logos__img"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
